import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_APPOINTMENT_BY_ID } from "../../../../../../../queries/v3/pages/CancelAppointment/queries/get-appointment-by-id.js";
import { fromAppointmentQueryToAppointment } from "../../../../../adapters/v3/pages/CancelAppointment/hooks/api/adapters/fromAppointmentQueryToAppointment.js";
const useAppointmentById = (variables, token = "") => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_ID, {
    variables,
    context: {
      forwardHeaders: {
        "Accept-Language": locale,
        Authorization: `Bearer ${token}`
      }
    }
  });
  const data = React.useMemo(() => {
    return queryState.data?.appointment ? fromAppointmentQueryToAppointment(
      queryState.data.appointment
    ) : null;
  }, [queryState]);
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data
      }
    ],
    [data, queryState, query]
  );
};
export {
  useAppointmentById as default
};
//# sourceMappingURL=use-appointment-by-id.js.map
